import { MenuItem, Select } from "@mui/material";
import { GridFilterOperator } from "@mui/x-data-grid-pro";
import createFilter from "./helpers/CreateFilterHelper";

const CustomFilterOperatorInputTaskStatusId = (props: any) => {
  const { item, applyValue } = props;
  const handleChange = (event: any) => {
    applyValue({ ...item, value: event.target.value });
  };
  return (

    <Select
      sx={{ maxWidth: '210px', width: '100%', justifyContent: 'center' }}
      labelId="status-select-label"
      value={item.value || ''}
      label="TaskStatus"
      onChange={handleChange}
      inputProps={{ id: "status-select", 'aria-label': 'Task Status Filter Input' }}
    >
      <MenuItem value={1}>Upcoming</MenuItem>
      <MenuItem value={2}>In Progress</MenuItem>
      <MenuItem value={3}>On Hold</MenuItem>
      <MenuItem value={7}>Cancelled</MenuItem>
      <MenuItem value={6}>Completed</MenuItem>
    </Select>
  );
};

const TaskStatusIdFilterOperator: GridFilterOperator[] = [
  {
      label: 'Is',
      value: 'eq',
      headerLabel: 'Is',
      getApplyFilterFn: createFilter((cellValue, filterValue) => {
          if (cellValue === undefined || filterValue === undefined) return false;

          return Number(cellValue) === Number(filterValue);
      }),
      InputComponentProps: { type: 'text' },
      InputComponent: CustomFilterOperatorInputTaskStatusId,
  }
];
  
export default TaskStatusIdFilterOperator;